/**
 Validates org numbers from Ireland, e.g. 123456
 */
export const validateIrelandOrgNumber = (number: string) => {
  const irelandOrgNumberRegex = /^[1-9]\d{1,6}$/g;

  return irelandOrgNumberRegex.test(number);
};
